// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"273":"420e6735","660":"c84fc23b"}[chunkId] + ".chunk.js";
};